<template>
    <div>
        <div v-if="showloader" class="loading loading-double"></div>
        <div v-else>
            <div id="middle-content">
                <section id="form_section" class="section with_pad">
                    <div class="container">
                        <div class="fieldsets">
                            <form method="POST" @submit.prevent="onSubmit"
                                @keydown="form.errors.clear($event.target.name)" enctype="multipart/form-data">
                                <fieldset v-for="(fieldset, indexfieldset) in forms" :key="indexfieldset">
                                    <legend>{{ fieldset.title }}</legend>
                                    <div v-for="(field, index) in fieldset.forms" :key="index">
                                        <div v-if="field.type == 'text'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="text" v-model="form[field.name]"
                                                    :placeholder="field.placeholder" class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'no_rangka'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="text" v-model="form[field.name]"
                                                    v-mask="'NNNN-NNNN-NNNN-NNNN-N'" :placeholder="field.placeholder"
                                                    class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'no_stnk'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="text" v-model="form[field.name]" v-mask="'########'"
                                                    :placeholder="field.placeholder" class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'no_sim'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="text" v-model="form[field.name]"
                                                    v-mask="'####-####-####-####'" :placeholder="field.placeholder"
                                                    class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'email'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="email" v-model="form[field.name]"
                                                    :placeholder="field.placeholder" class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'textarea'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <textarea v-model="form[field.name]" :placeholder="field.placeholder"
                                                    class="form-control col-grid-70"></textarea>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'phone'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input type="tel" v-model="form[field.name]"
                                                    :placeholder="field.placeholder" class="form-control col-grid-70">
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'datepicker'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-date-picker @input="updateDate($event, field.name)" mode="date"
                                                    :v-model="datepicker" :value="form[field.name]"
                                                    :name="form[field.name]" :masks="masks"
                                                    class="col-grid-70 input-datepicker">
                                                </v-date-picker>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'timepicker'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-date-picker @popoverWillHide="updateTime($event, field.name)"
                                                    :value="form[field.name]" mode="time" v-model="timepicker"
                                                    :name="form[field.name]" class="col-grid-70 input-datepicker">
                                                    <template v-slot="{ inputValue, inputEvents }">
                                                        <input :placeholder="field.placeholder" class="form-control"
                                                            :value="inputValue" v-on="inputEvents" />
                                                    </template>
                                                </v-date-picker>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'radio'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <div v-if="field.option">
                                                    <div class="radio-list" v-for="(option, index) in field.option"
                                                        :key="index">
                                                        <input type="radio" :name="form[field.name]"
                                                            v-model="form[field.name]" :value="option.value">
                                                        <span>{{ option.value }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'dropdown'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="field.option"
                                                    :placeholder="field.placeholder" v-model="form[field.name]">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'province'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="provinces"
                                                    label="name" :placeholder="field.placeholder"
                                                    @input="changeProvince($event, field.name)" v-model="province">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'city'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="cities"
                                                    label="name" :placeholder="field.placeholder"
                                                    @input="changeCity($event, field.name)" v-model="city">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'motor_category'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70"
                                                    :options="productscategories" label="title"
                                                    :placeholder="field.placeholder"
                                                    @input="changeMotorCategory($event, field.name)"
                                                    v-model="productcategories">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'motor_category_with_others'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70"
                                                    :options="productscategorieswithothers" label="title"
                                                    :placeholder="field.placeholder"
                                                    @input="changeMotorCategoryWithOthers($event, field.name)"
                                                    v-model="productscategorieswithother">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'motor'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <input v-if="productscategorieswithother == 'Lain-lain'" type="text"
                                                    v-model="form[field.name]" :placeholder="field.placeholder"
                                                    class="form-control col-grid-70">
                                                <v-select v-else class="custom_vselect2 col-grid-70" :options="products"
                                                    label="title" :placeholder="field.placeholder"
                                                    @input="changeMotor($event, field.name)" v-model="product">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'year'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="years"
                                                    :placeholder="field.placeholder" v-model="form[field.name]">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'area'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="areas"
                                                    label="name" :placeholder="field.placeholder"
                                                    @input="changeArea($event, field.name)" v-model="area">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'region'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="custom_vselect2 col-grid-70" :options="regions"
                                                    label="name" :placeholder="field.placeholder"
                                                    @input="changeRegion($event, field.name)" v-model="region"
                                                    :disabled="fieldset.forms.some(item => item.type === 'police_code')">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'police_code'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <div class="col-grid-70">
                                                    <div class="flex input-police-code">
                                                        <v-select class="form-control w40" :options="police_codes"
                                                            label="code" placeholder="Pilih Kode"
                                                            @input="changePoliceCode($event, field.name, fieldset.forms.find(item => item.type === 'region'))"
                                                            v-model="police_code">
                                                        </v-select>
                                                        <input type="text" v-model="police_number"
                                                            @input="changePoliceNumber(field.name)"
                                                            :placeholder="field.placeholder" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'motor_class'" class="input-group">
                                            <div class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <v-select class="form-control col-grid-70" :options="motor_classes"
                                                    label="name" :placeholder="field.placeholder"
                                                    @input="changeMotorClass($event, field.name)" v-model="motor_class">
                                                </v-select>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'dropzone'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <single-upload class="col-grid-70" :limit="1"
                                                    @uploaded="uploadedfile($event, field.name)" :dropid="'field-' + index"
                                                    :placeholder="field.placeholder" :endpoint="api_asset_url + '/upload'"
                                                    :folder="field.name" :model="form[field.name]" :user="user"
                                                    extension=".zip,.pdf"></single-upload>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                                <span class="help-block" v-if="dataerrors.hasOwnProperty(field.name)"
                                                    v-text="dataerrors[field.name]"></span>
                                            </div>
                                        </div>
                                        <div v-if="field.type == 'dropzone_image'" class="input-group">
                                            <div :id="form.errors.has(field.name) ? 'error-field' : false"
                                                class="row-grid">
                                                <label :for="field.label" class="col-grid-30">{{ field.label }}</label>
                                                <single-upload class="col-grid-70" :limit="1"
                                                    @uploaded="uploadedfile($event, field.name)" :dropid="'field-' + index"
                                                    :placeholder="field.placeholder" :endpoint="api_asset_url + '/upload'"
                                                    :folder="field.name" :model="form[field.name]" :user="user"
                                                    extension=".jpeg,.jpg,.png,.gif,.svg,.webp"></single-upload>
                                            </div>
                                            <div class="row-grid">
                                                <div class="col-grid-30"></div>
                                                <span class="help-block" v-if="form.errors.has(field.name)"
                                                    v-text="form.errors.get(field.name)"></span>
                                                <span class="help-block" v-if="dataerrors.hasOwnProperty(field.name)"
                                                    v-text="dataerrors[field.name]"></span>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="form-group">
                                        <div class="row-grid">
                                            <div class="col-grid-5">
                                                <input type="checkbox" class="checkbox" name="agree"
                                                    v-model="form.agree">
                                            </div>
                                            <span class="col-grid-90">Saya menyetujui syarat ketentuan yang
                                                berlaku</span>
                                        </div>
                                        <div class="row-grid">
                                            <div class="col-grid-5"></div>
                                            <span class="help-block" v-if="form.errors.has('agree')"
                                                v-text="form.errors.get('agree')"></span>
                                        </div>
                                    </div>
                                </fieldset>
                                <div class="form-group">
                                    <div class="center-button flex flex-center fix-button">
                                        <div class="container flex" v-if="schedule.is_join">
                                            <a v-scroll-to="'#main'" class="back-to-top"><i
                                                    class="ion-chevron-up"></i></a>
                                            <a class="btn btn-primary btn-black">
                                                ANDA SUDAH JOIN
                                            </a>
                                        </div>
                                        <div class="container flex" v-else>
                                            <a v-scroll-to="'#main'" class="back-to-top"><i
                                                    class="ion-chevron-up"></i></a>
                                            <div v-if="loader" class="loading loading-double"></div>
                                            <button v-else type="submit" class="btn btn-primary btn-black">
                                                JOIN EVENT
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--end.wrapper-->
                </section>
            </div>
        </div>
        <popup-message ref="popupMessage"></popup-message>
    </div>
</template>

<script>
// Main JS (in UMD format)

import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Upload from '../../SingleUpload';
import PopupMessage from '../../widget/PopupMessage';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    props: ['model_id', 'endpoint', 'form_url', 'model', 'member', 'modelschedule'],
    components: {
        "v-select": vSelect,
        'single-upload': Upload,
        'popup-message': PopupMessage
    },
    data() {
        return {
            event: null,
            schedule: null,
            base_url: base_url,
            api_asset_url: api_asset_url,
            user: null,
            submission: null,
            showloader: true,
            loader: false,
            success: false,
            datepicker: new Date(),
            timepicker: new Date(),
            areas: [],
            area: null,
            regions: [],
            region: null,
            motor_classes: [],
            motor_class: null,
            police_codes: [],
            police_code: null,
            police_number: null,
            provinces: [],
            province: null,
            cities: [],
            city: null,
            products: [],
            product: [],
            productscategories: [],
            productscategorieswithothers: [],
            productscategorieswithother: null,
            productcategory: null,
            productcategories: null,
            fieldsets: [],
            years: [],
            forms: {},
            dataerrors: {},
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            masks: {
                input: 'YYYY-MM-DD',
            },
            form: null,
        };
    },

    watch: {
        police_number(data) {
            this.form['police_number'] = data;
        },
    },
    methods: {
        onSubmit() {
            this.loader = true;
            var app = this;
            var form = this.form;
            this.form.post(this.endpoint).then((response) => {
                this.loader = false;
                localStorage.setItem('join-event-success', JSON.stringify(this.schedule));
                window.location.href = app_url + "/submission-thankyou/" + this.schedule.slug
            }).catch((response) => {
                console.log(response)
                app.$refs.popupMessage.close();
                app.$scrollTo('#error-field')
                app.loader = false;
            });
        },
        fetchArea(fieldname = null) {
            axios.get(api_url + "/area").then((response) => {
                this.areas = response.data;
            });
        },
        fetchRegion(fieldname = null) {
            axios.get(api_url + "/region").then((response) => {
                this.regions = response.data;
            });
        },
        fetchMotorClass(fieldname = null) {
            axios.get(api_url + "/motor-class").then((response) => {
                this.motor_classes = response.data;
            });
        },
        fetchPoliceCode(fieldname = null) {
            axios.get(api_url + "/police-code").then((response) => {
                this.police_codes = response.data;
            });
        },
        fetchProvince(fieldname = null) {
            axios.get(main_api_url + "/province").then((response) => {
                this.provinces = response.data;
            });
        },
        fetchCity(province, fieldname = null) {
            if (province) {
                axios.get(main_api_url + "/city?province=" + province).then((response) => {
                    this.cities = response.data;
                });
            } else {
                axios.get(main_api_url + "/city").then((response) => {
                    this.cities = response.data;
                });
            }
        },
        fetchYear(fieldname = null) {
            axios.get(main_api_url + "/setting?type=yearproduct").then((response) => {
                this.years = response.data;
            });
        },
        fetchProduct(category, fieldname = null) {
            if (category) {
                axios.get(main_api_url + "/product?category=" + category.id)
                    .then((response) => {
                        this.products = response.data;
                    });
            } else {
                axios.get(main_api_url + "/product")
                    .then((response) => {
                        this.products = response.data;
                    });
            }
        },
        fetchProductCategories(fieldname = null) {
            axios.get(main_api_url + "/product/category").then((response) => {
                this.productscategories = response.data;
            });
        },
        fetchProductCategoriesWithOthers(fieldname = null) {
            axios.get(main_api_url + "/product/category").then((response) => {
                this.productscategorieswithothers = response.data;
                var others = {
                    id: "lain-lain",
                    title: "Lain-lain",
                    name: "Lain-lain",
                    slug: "lain-lain",
                    type: "product",
                };
                var nomotors = {
                    id: "tidak-memiliki-motor",
                    title: "Tidak memiliki motor​",
                    name: "Tidak memiliki motor​",
                    slug: "tidak-memiliki-motor",
                    type: "product",
                };
                this.productscategorieswithothers.push(others);
                this.productscategorieswithothers.push(nomotors);
            });
        },
        changeProvince(event, field_name) {
            if (event) {
                this.fetchCity(event.id);
                this.form[field_name] = event.name;
            }
        },
        changeMotorCategory(event, field_name) {
            if (event) {
                this.productcategory = event.title;
                this.fetchProduct(event);
                this.form[field_name] = event.title;
            }
        },
        changeMotorCategoryWithOthers(event, field_name) {
            if (event) {
                this.productscategorieswithother = event.title;
                this.fetchProduct(event);
                this.form[field_name] = event.title;
            }
        },
        changePoliceCode(event, field_name, region_field) {
            if (event) {
                var region = this.regions.find(item => item.id === event.region_id);
                this.region = region;
                this.form[region_field.name] = region.name;
                this.form[field_name] = event.code;
            }
        },
        changePoliceNumber(field_name) {
            this.form[field_name] = this.police_code.code + ' ' + this.police_number;
        },
        changeMotor(event, field_name) {
            if (event) {
                this.form[field_name] = event.title;
            }
        },
        changeCity(event, field_name) {
            if (event) {
                this.form[field_name] = event.name;
            }
        },
        changeMotorClass(event, field_name) {
            if (event) {
                this.form[field_name] = event.name;
            }
        },
        changeArea(event, field_name) {
            if (event) {
                this.form[field_name] = event.name;
            }
        },
        changeRegion(event, field_name) {
            if (event) {
                this.form[field_name] = event.id;
            }
        },
        changeDropdown(event, field_name) {
            if (event) {
                this.form[field_name] = event.value;
            }
        },
        updateDate(event, field_name) {
            this.form[field_name] = this.datepicker.toLocaleDateString();
        },
        updateTime(event, field_name) {
            this.form[field_name] = this.timepicker.toLocaleTimeString();
        },
        fetchForm() {
            axios.get(this.form_url).then((response) => {
                // this.submission = response.data.submission;
                this.user = this.member;
                console.log(this.user);
                this.forms = response.data.fieldsets;
                this.forms.forEach(element => {
                    element.forms.forEach(form => {
                        if (form.type == 'province') {
                            this.fetchProvince(form.name);
                        }
                        if (form.type == 'city') {
                            this.fetchCity(null, form.name);
                        }
                        if (form.type == 'motor') {
                            this.fetchProduct(null, form.name);
                        }
                        if (form.type == 'motor_category_with_others') {
                            this.fetchProductCategoriesWithOthers(form.name);
                        }
                        if (form.type == 'motor_category') {
                            this.fetchProductCategories(form.name);
                        }
                        if (form.type == 'area') {
                            this.fetchArea(form.name);
                        }
                        if (form.type == 'region') {
                            this.fetchRegion(form.name);
                        }
                        if (form.type == 'motor_class') {
                            this.fetchMotorClass(form.name);
                        }
                        if (form.type == 'police_code') {
                            this.fetchPoliceCode(form.name);
                        }
                        if (form.type == 'year') {
                            this.fetchYear(form.name);
                        }
                    });
                });
                var obj = response.data.form;
                var pair = { _token: token, event_id: this.event.id, event_schedule_id: this.schedule.id };
                obj = { ...obj, ...pair };
                this.form = new Form(obj);
                // if(this.submission){
                //   for(var key in this.submission.submission) {
                //     if(this.submission.submission[key] == 'null'){
                //     this.form[key] = '';
                //     }else{
                //     this.form[key] = this.submission.submission[key]
                //     }
                //   }
                // }
                this.showloader = false;
            });
        },
        uploadedfile(event, field_name) {
            if (event) {
                if (event.type == 'create') {
                    this.dataerrors = {};
                    this.form[field_name] = event.data[0].url;
                } else if ((event.type == 'error')) {
                    this.form[field_name] = '';
                    this.dataerrors = event.data;
                } else if ((event.type == 'remove')) {
                    this.form[field_name] = '';
                }
            }
        },
    },
    created() {
        this.fetchForm();
        this.event = this.model;
        this.schedule = this.modelschedule;
    },
};
</script>
<style scoped lang="scss">
.input-police-code {
    margin: 0 -15px;
}

.w40 {
    width: 170px;
    margin-right: 15px;
}

.input-datepicker {
    padding: 0;
}

.row-grid {
    margin: 0;
}

.input-group {
    margin-bottom: 20px;

    .col-grid-30 {
        display: flex;
        align-items: center;
    }
}

.fix-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 500;
    background: #FAFAFA;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 12px 0;
    display: flex;
    align-items: center;

    .btn {
        font-weight: bold;
    }

    .back-to-top {
        background-color: #E61B33;
        color: #fff;
        font-size: 14px;
        border-radius: 10px;
        display: block;
        width: 38px;
        height: 38px;
        cursor: pointer;
        margin-right: auto;
        line-height: 38px;
        text-align: center;
    }

    .back-to-top:hover {
        background-color: #000;
    }
}

.help-block {
    padding: 5px 0;
    margin: 0 -10px;
}
</style>
